import { createProviderToken } from '@core/common-legacy';
import type { SymbolPickerTranslations } from '@core/symbol-data';

export const { provide: provideSymbolPickerTranslations, inject: injectSymbolPickerTranslations } =
  createProviderToken<SymbolPickerTranslations>('SymbolPickerTranslations')();
